import { createSelector } from 'reselect';
import { isEmpty } from 'lodash';
import moment from 'config/Moment';

export const Types = {
  GET_LIST_REQUEST: 'journeys/GET_LIST_REQUEST',
  GET_LIST_SUCCESS: 'journeys/GET_LIST_SUCCESS',
  GET_LIST_FAILURE: 'journeys/GET_LIST_FAILURE',

  GET_REQUEST: 'journeys/GET_REQUEST',
  GET_SUCCESS: 'journeys/GET_SUCCESS',
  GET_FAILURE: 'journeys/GET_FAILURE',

  UPDATE_REQUEST: 'journeys/UPDATE_REQUEST',
  UPDATE_SUCCESS: 'journeys/UPDATE_SUCCESS',
  UPDATE_FAILURE: 'journeys/UPDATE_FAILURE',

  CREATE_REQUEST: 'journeys/CREATE_REQUEST',
  CREATE_SUCCESS: 'journeys/CREATE_SUCCESS',
  CREATE_FAILURE: 'journeys/CREATE_FAILURE',
};

const initialState = {
  data: [],
  loading: false,

  journey: {
    data: {},
    loading: false,
  },

  update: {
    loading: false,
  },

  create: {
    loading: false,
  },
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Types.GET_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Types.GET_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.journeys.data,
      };
    case Types.GET_LIST_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case Types.GET_REQUEST:
      return {
        ...state,
        journey: {
          ...state.journey,
          loading: true,
        },
      };
    case Types.GET_SUCCESS:
      return {
        ...state,
        journey: {
          ...state.journey,
          data: action.payload.journey.data,
          loading: false,
        },
      };
    case Types.GET_FAILURE:
      return {
        ...state,
        journey: {
          ...state.journey,
          loading: false,
        },
      };
    case Types.UPDATE_REQUEST:
      return {
        ...state,
        update: {
          ...state.update,
          loading: true,
        },
      };
    case Types.UPDATE_SUCCESS:
    case Types.UPDATE_FAILURE:
      return {
        ...state,
        update: {
          ...state.update,
          loading: false,
        },
      };
    case Types.CREATE_REQUEST:
      return {
        ...state,
        create: {
          ...state.create,
          loading: true,
        },
      };
    case Types.CREATE_SUCCESS:
    case Types.CREATE_FAILURE:
      return {
        ...state,
        create: {
          ...state.create,
          loading: false,
        },
      };
    default:
      return state;
  }
}

export const Creators = {
  getJourneysRequest: (page = 1, query = null) => ({
    type: Types.GET_LIST_REQUEST,
    payload: { page, query },
  }),

  getJourneysSuccess: journeys => ({
    type: Types.GET_LIST_SUCCESS,
    payload: { journeys },
  }),

  getJourneysFailure: () => ({
    type: Types.GET_LIST_FAILURE,
  }),

  getJourneyRequest: id => ({
    type: Types.GET_REQUEST,
    payload: { id },
  }),

  getJourneySuccess: journey => ({
    type: Types.GET_SUCCESS,
    payload: { journey },
  }),

  getJourneyFailure: () => ({
    type: Types.GET_FAILURE,
  }),

  updateJourneyRequest: (id, data) => ({
    type: Types.UPDATE_REQUEST,
    payload: { id, data },
  }),

  updateJourneySuccess: () => ({
    type: Types.UPDATE_SUCCESS,
  }),

  updateJourneyFailure: () => ({
    type: Types.UPDATE_FAILURE,
  }),

  createJourneyRequest: data => ({
    type: Types.CREATE_REQUEST,
    payload: { data },
  }),

  createJourneySuccess: () => ({
    type: Types.CREATE_SUCCESS,
  }),

  createJourneyFailure: () => ({
    type: Types.CREATE_FAILURE,
  }),
};

export const Selectors = {
  search: createSelector(
    state => state,
    journeys =>
      journeys.map(journey => ({
        label: journey.attributes.name,
        value: journey.id,
      })),
  ),

  list: createSelector(
    state => state,
    journeys =>
      journeys.map(journey => ({
        ...journey,
        attributes: {
          ...journey.attributes,
          available_from: moment(journey.attributes['available-from']).format('DD/MM/YYYY HH:mm'),
          available_until:
            journey.attributes['available-until'] !== null
              ? moment(journey.attributes['available-until']).format('DD/MM/YYYY HH:mm')
              : '-',
        },
      })),
  ),

  detail: createSelector(
    state => state,
    journey =>
      !isEmpty(journey)
        ? {
            ...journey,
            attributes: {
              ...journey.attributes,
              east_face_quiz: {
                ...journey.attributes['east-face-quiz'],
                value: journey.attributes['east-face-quiz'].id,
                label: journey.attributes['east-face-quiz'].title,
              },
              west_face_quiz: {
                ...journey.attributes['west-face-quiz'],
                value: journey.attributes['west-face-quiz'].id,
                label: journey.attributes['west-face-quiz'].title,
              },
              north_face_quiz: {
                ...journey.attributes['north-face-quiz'],
                value: journey.attributes['north-face-quiz'].id,
                label: journey.attributes['north-face-quiz'].title,
              },
              south_face_quiz: {
                ...journey.attributes['south-face-quiz'],
                value: journey.attributes['south-face-quiz'].id,
                label: journey.attributes['south-face-quiz'].title,
              },
            },
          }
        : {},
  ),
};



// WEBPACK FOOTER //
// ./src/store/ducks/journeys.js